import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumPageDisplayModes, EnumPageEntitySources, EnumWindowSizes } from '@core/framework/sysenums.enum';
import { Html5Qrcode, Html5QrcodeScanner } from "html5-qrcode";
import { Html5QrcodeCameraScanConfig } from "html5-qrcode/esm/html5-qrcode";
import { Html5QrcodeResult } from "html5-qrcode/esm/core";
import { DxPopupComponent } from 'devextreme-angular';
import { TemplateRef } from '@angular/core';

class State extends BaseState {
    DeviceIDs: string[] = [];
    CurrentDeviceIndex = null;
    IsInititialized: boolean = false;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-barcodeboxdialog',
    templateUrl: './barcodeboxdialog.component.html',
    styleUrls: ['./barcodeboxdialog.component.scss']
})
export class BarcodeBoxDialogComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('reader') ReaderElement: ElementRef | undefined;

    @Input() UseFrontCamera: boolean = false;
    @Input() Config: Html5QrcodeCameraScanConfig = { fps: 10, qrbox: { width: 250, height: 250 } };
    @Input() ExtraFields: TemplateRef<any>;
    @Output() OnTextDecoded: EventEmitter<string> = new EventEmitter<string>();
    @Output() OnResultDecoded: EventEmitter<Html5QrcodeResult> = new EventEmitter<Html5QrcodeResult>();
    html5QrCode!: Html5Qrcode;

    constructor(A: ServiceBagService) {
        super(A, 'BarcodeBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override OnInitComponent() {
        this.State.IsInititialized = true;
    }

    protected override OnInitComponentFinished() {

        Html5Qrcode.getCameras().then(devices => {
            if (devices && devices.length) {
                this.State.DeviceIDs = devices.map(x => x.id);
                this.State.CurrentDeviceIndex = this.State.DeviceIDs.length - 1;
                this.StartHtmlQrCode();
            }
        }).catch(err => {
            console.log(err);
        });

        //let html5QrcodeScanner = new Html5QrcodeScanner("reader", undefined, false);
        //html5QrcodeScanner.render(this.onScanSuccess, this.onScanFailure);
    }

    protected override OnDestroyComponent() {
        this.State.IsInititialized = false;
    }

    protected override OnClose() {
        if (this.StopHtml5QrCode(false)) return false;
        this.CloseDialogWithCancel();
        return false;
    }

    private StartHtmlQrCode() {
        if (this.html5QrCode?.isScanning) {
            this.html5QrCode.stop().then((ignore) => {
                this.html5QrCode.start(
                    { deviceId: this.State.DeviceIDs[this.State.CurrentDeviceIndex] },
                    this.Config,
                    this.QrCodeSuccessCallback,
                    (error) => { })
                    .catch((err) => {
                        console.log(err);
                    });
            }).catch((err) => {
                console.error(err);
            });
            return;
        }

        this.html5QrCode = new Html5Qrcode(this.ReaderElement?.nativeElement?.id);
        this.html5QrCode.start(
            { deviceId: this.State.DeviceIDs[this.State.CurrentDeviceIndex] },
            this.Config,
            this.QrCodeSuccessCallback,
            (error) => { })
            .catch((err) => {
                console.log(err);
            });
    }

    private StopHtml5QrCode(isSuccess) {
        if (this.html5QrCode) {
            this.html5QrCode.stop().then((ignore) => {
                isSuccess ? this.CloseDialogWithSuccess() : this.CloseDialogWithCancel();
            }).catch((err) => {
                console.error(err);
                this.CloseDialogWithCancel();
            });
            return true;
        }
    }

    OnBarcodeClick (e) {
        this.State.CurrentDeviceIndex++;
        this.State.CurrentDeviceIndex = this.State.CurrentDeviceIndex % this.State.DeviceIDs.length;
        this.StartHtmlQrCode();
    }

    QrCodeSuccessCallback = (decodedText: any, decodedResult: Html5QrcodeResult) => {
        this.OnTextDecoded.emit(decodedText);
        this.OnResultDecoded.emit(decodedResult);
    }

    CloseDialog(isSuccess: boolean) {
        if (this.StopHtml5QrCode(isSuccess)) return;
        this.CloseDialogWithCancel();
    }
}